module.exports = __webpack_public_path__ + "img/phone-icon.e4e247ed.png";